import { useToast } from "vue-toastification";
import _ from "lodash"; // استيراد مكتبة lodash
import { usePage } from "@inertiajs/vue3";
import { is_enabled_module } from "./usePermission";
import { HandleErrorAxios } from "./HandleError";
import { ref } from "vue";
import { useStorage } from "@vueuse/core";
const storedCountry = useStorage('selectedCountry', null);
const page = usePage();


/**
 * @typedef {('featured' | 'popular' | 'recommended' | 'acil' | 'new')} GetIsType
 */

/**
 * Fetches a list of products (ads) based on the provided parameters.
 *
 * @param {Object} params - The parameters to filter and sort the products.
 * @param {string} [params.search='any word'] - The field to search in products. Default is null.
 * @param {string} [params.sortBy='id'] - The field to sort the products by. Default is 'id'.
 * @param {string} [params.direction='desc'] - The direction of sorting. Can be 'asc' or 'desc'. Default is 'desc'.
 * @param {number} [params.limit=50] - The maximum number of products to return. Default is 50.
 * @param {GetIsType} [params.get_is=null] - Filter products by a specific type. Can be one of: 'featured', 'popular', 'recommended', 'acil', 'new'. Default is null.
 * @returns {Promise<Array>} - A promise that resolves to an array of products.
 *
 * @example
 * fetchProducts({
 *   search: 'any word',
 *   sortBy: 'id',
 *   direction: 'desc',
 *   limit: 50,
 *   get_is: 'featured'
 * }).then(products => {
 *   console.log(products);
 * }).catch(error => {
 *   console.error('Failed to fetch products:', error);
 * });
 */
export async function fetchProducts(params = {}) {
    if (!is_enabled_module('product')) {
        return [];
    }

    // تعيين القيم الافتراضية
    const {
        search = null,
        sortBy = 'id',
        direction = 'desc',
        limit = 50,
        get_is = null,
    } = params;

    try {
        const response = await axios.get(route('api.products.listOf'), {
            params: {
                search,
                sortBy,
                direction,
                limit,
                get_is,
                country_id:parseInt(storedCountry.value)
            },
        });

        return response.data.data; // إرجاع البيانات
    } catch (error) {
        console.error('Failed to fetch products:', error);
        throw error; // إعادة رمي الخطأ للتعامل معه في الكود الذي يستدعي الدالة
    }
}
/**
 * @typedef {('featured' | 'popular' | 'recommended' | 'acil' | 'new')} GetIsType
 */

/**
 * Fetches a list of products (ads) based on the provided parameters.
 *
 * @param {Object} params - The parameters to filter and sort the products.
 * @param {string} [params.search='any word'] - The field to search in products. Default is null.
 * @param {string} [params.sortBy='id'] - The field to sort the products by. Default is 'id'.
 * @param {string} [params.direction='desc'] - The direction of sorting. Can be 'asc' or 'desc'. Default is 'desc'.
 * @param {number} [params.limit=50] - The maximum number of products to return. Default is 50.
 * @param {GetIsType} [params.get_is=null] - Filter products by a specific type. Can be one of: 'featured', 'popular', 'recommended', 'acil', 'new'. Default is null.
 * @returns {Promise<Array>} - A promise that resolves to an array of products.
 *
 * @example
 * fetchProducts({
 *   search: 'any word',
 *   sortBy: 'id',
 *   direction: 'desc',
 *   limit: 50,
 *   get_is: 'featured'
 * }).then(products => {
 *   console.log(products);
 * }).catch(error => {
 *   console.error('Failed to fetch products:', error);
 * });
 */
export async function fetchServices(params = {}) {
    if (!is_enabled_module('service')) {
        return [];
    }

    // تعيين القيم الافتراضية
    const {
        search = null,
        sortBy = 'id',
        direction = 'desc',
        limit = 50,
        get_is = null,
    } = params;

    try {
        const response = await axios.get(route('api.services.listOf'), {
            params: {
                search,
                sortBy,
                direction,
                limit,
                get_is,
                country_id:parseInt(storedCountry.value)
            },
        });

        return response.data.data; // إرجاع البيانات
    } catch (error) {
        console.error('Failed to fetch services:', error);
        throw error; // إعادة رمي الخطأ للتعامل معه في الكود الذي يستدعي الدالة
    }
}


/**
 * تقوم هذه الدالة بجلب قائمة الفئات (Categories) من واجهة برمجة التطبيقات (API).
 * يمكن تخصيص عملية الجلب باستخدام معاملات مثل البحث، الترتيب، الحد الأقصى للنتائج، وغيرها.
 *
 * @async
 * @function fetchCategories
 * @param {Object} [params={}] - كائن يحتوي على معاملات لتخصيص عملية الجلب.
 * @param {string} [params.search=null] - نص البحث للبحث عن فئات محددة.
 * @param {string} [params.sortBy='sort'] - الحقل الذي يتم الترتيب بناءً عليه.
 * @param {string} [params.direction='asc'] - اتجاه الترتيب (تصاعدي أو تنازلي).
 * @param {number} [params.limit=50] - الحد الأقصى لعدد الفئات المراد جلبها.
 * @param {boolean} [params.withCount=false] - إذا كان `true`، يتم تضمين عدد العناصر المرتبطة بكل فئة.
 * @param {boolean} [params.withChildren=false] - إذا كان `true`، يتم تضمين الفئات الفرعية.
 * @param {number} [params.levelChildren=1] - مستوى الفئات الفرعية المطلوب جلبها.
 * @param {number} [params.skip_id=null] - معرف الفئة التي يجب استبعادها من النتائج.
 * @returns {Promise<Array>} - وعد (Promise) يحل إلى مصفوفة تحتوي على بيانات الفئات.
 * @throws {Error} - يتم رمي خطأ إذا فشل طلب API.
 */
export async function fetchCategories(params = {}) {
    if (!is_enabled_module('product')) {
        return [];
    }

    // تعيين القيم الافتراضية
    const {
        search = null,
        sortBy = 'sort',
        direction = 'asc',
        limit = 50,
        withCount = false,
        withChildren = false,
        levelChildren = 1,
        skip_id = null,
    } = params;

    try {
        const response = await axios.get(route('api.category.index'), {
            params: {
                search,
                sortBy,
                direction,
                limit,
                withCount,
                withChildren,
                levelChildren,
                skip_id,
                country_id:parseInt(storedCountry.value)
            },
        });

        return response.data.data; // إرجاع البيانات
    } catch (error) {
        console.error('Failed to fetch categories:', error);
        throw error; // إعادة رمي الخطأ للتعامل معه في الكود الذي يستدعي الدالة
    }
}

/**
 * Fetches a single category by its slug with optional parameters.
 *
 * @param {string} slug - The slug of the category to fetch.
 * @param {Object} [params={}] - Optional parameters for the request.
 * @param {string|null} [params.search=null] - Search term to filter results.
 * @param {Object|null} [params.filters=null] - Filters to apply to the results.
 * @param {string} [params.sortBy='sort'] - The field to sort by.
 * @param {string} [params.direction='asc'] - The direction of sorting ('asc' or 'desc').
 * @param {number} [params.limit=50] - The maximum number of results to return.
 * @param {boolean} [params.withCount=false] - Whether to include the count of results.
 * @param {boolean} [params.withChildren=true] - Whether to include child categories.
 * @param {boolean} [params.withParent=false] - Whether to include the parent category.
 * @param {boolean} [params.withProducts=false] - Whether to include related products.
 * @param {boolean} [params.withMultiLevelChildrenProducts=false] - Whether to include multi-level children products.
 * @param {number} [params.levelChildren=1] - The level of children to include.
 * @returns {Promise<Array>} - A promise that resolves to the fetched category data.
 * @throws {Error} - Throws an error if the request fails.
 */
export async function fetchSingleCategory(slug, params = {}) {
    if (!is_enabled_module('product')) {
        return [];
    }

    // تعيين القيم الافتراضية
    const {
        search = null,
        filters = null,
        sortBy = 'sort',
        direction = 'asc',
        limit = 50,
        withCount = false,
        withChildren = true,
        withParent = false,
        withProducts = false,
        withMultiLevelChildrenProducts = false,
        levelChildren = 1,
    } = params;

    try {
        const response = await axios.get(route('api.category.show', slug), {
            params: {
                search,
                filters: filters ? JSON.stringify(filters) : null, // تحويل الفلتر إلى JSON إذا كان موجودًا
                sortBy,
                direction,
                limit,
                withCount,
                withChildren,
                withParent,
                withProducts,
                withMultiLevelChildrenProducts,
                levelChildren,
                country_id:parseInt(storedCountry.value)
            },
        });

        return response.data.data; // إرجاع البيانات
    } catch (error) {
        console.error('Failed to fetch categories:', error);
        throw error; // إعادة رمي الخطأ للتعامل معه في الكود الذي يستدعي الدالة
    }
}

export async function fetchProductsPage(page = 1, perPage = 20, filters = {}) {
    try {
        const response = await axios.get(route('api.products.index'), {
            params: {
                page,
                per_page: perPage,
                ...filters,
                country_id:parseInt(storedCountry.value)

            },
        });

        return response.data.data; // إرجاع البيانات
    } catch (error) {
        console.error('Failed to fetch products:', error);
        throw error;
    }
}


export function diff(obj1, obj2) {
    const result = {};
    for (const key in obj1) {
        if (!_.isEqual(obj1[key], obj2[key])) {
            // console.log(obj1[key], obj2[key]);
            result[key] = obj1[key];
        }
    }
    return result;
}

export function submit(settings, setting, callback) {
    if (page.props.mode == "readonly") {
        return useToast().warning("Demo mode");
    }
    let afterRequest = {
        preserveState: true,
        onStart: () => (callback.loading.value = true),
        onFinish: () => (callback.loading.value = false),
        onSuccess: (page) => {
            callback.$inertia.reload();
            let msg = page.props.flash.message
                ? page.props.flash.message
                : "Settings saved successfully";
            useToast().success(msg);
        },
        onError: (error) => {
            if (Object.keys(error).length >= 1) {
                useToast().error(error[Object.keys(error)[0]]);
            } else {
                useToast().error(__t("something_went_wrong"));
            }
        },
    };

    // console.log(setting);
    // console.log(setting.data());
    const localChanges = diff(setting.data(), settings);
    console.log(localChanges);
    callback.$inertia.post(
        route("admin.settings.save"),
        {
            _method: "post",
            setting: localChanges,
        },
        afterRequest
    );
}
